import { useEffect } from 'react';
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from 'prop-types';
import useI18n from "../../hooks/useI18n";
import { useNavigate, useParams } from "react-router-dom";
import { changeLoadingText, toggleLoading } from "../../services/helpers";
import useEnv from "../../hooks/useEnv";

const messages = defineMessages({
    redirecting: {
        id: "Sinut ohjataan tunnistuspalveluun",
        defaultMessage: "Sinut ohjataan tunnistuspalveluun"
    },
    redirectingUserId: {
        id: "Sinut ohjataan kirjautumissivulle",
        defaultMessage: "Sinut ohjataan kirjautumissivulle"
    },
    inSeconds: {
        id: "sekunnin kuluttua",
        defaultMessage: "sekunnin kuluttua"
    }
});
export { messages };


const Link = (props) => {
    const lng = props.intl.formatMessage;
    const { dpid, customertype } = useParams();
    const { isEnvTruthy } = useEnv();
    const { getLocale } = useI18n();
    const userLocale = getLocale();
    const navigate = useNavigate();

    const msg = isEnvTruthy('USER_ID_SIGN_IN')
        ? messages.redirectingUserId
        : messages.redirecting;

    /**
     * Log out user from loading and redirect to frontpage
     */
    useEffect(() => {
        let time = 5;

        // Loading animation for redirect
        toggleLoading(true, lng(msg) + " " + time + " " + lng(messages.inSeconds) + "...");

        // DPID comes as a parameter from address bar
        if (dpid) {
            // Save to sessionStorage for search
            sessionStorage.setItem('dpid', dpid);
        }

        // 5 sec timer for redirect
        const redirectInterval = setInterval(() => {
            if (time > 1) {
                time = time - 1;
                changeLoadingText(lng(msg) + " " + time + " " + lng(messages.inSeconds) + "...");
            } else {
                clearInterval(redirectInterval);
                let search = '';
                // if customertype is 1 (company) and REACT_APP_COMPANY_TOGGLE is ON (1) redirect to company login
                if (isEnvTruthy('COMPANY_TOGGLE') && customertype === '1') {
                    search = isEnvTruthy('USER_ID_SIGN_IN') ? '?customerType=company' : '&customertype=1';
                }
                if (isEnvTruthy('USER_ID_SIGN_IN')) {
                    navigate({ pathname: '/user/signin', search }, { replace: true });
                } else {
                    window.location.href = process.env.REACT_APP_AUTH_URL + '?language=' + userLocale + search;
                }
            }
        }, 1000);

        return () => {
            clearInterval(redirectInterval);
            toggleLoading(false);
        }
    }, []);

    return null;
}

Link.propTypes = {
    intl: PropTypes.object.isRequired
}

export default injectIntl(Link);
